import React from 'react';
import '../../styles/ImageShowcase.scss';

const ImageShowcase = () => {
  const images = [
    "/Gemini_Generated_Image_2azxx02azxx02azx.png",
    
    "/Gemini_Generated_Image_6tjpyf6tjpyf6tjp.png",
    "/Gemini_Generated_Image_xkh4tvxkh4tvxkh4.png"
  ];

  return (
    <div className="image-showcase">
      <div className="image-showcase__container">
        {images.map((image, index) => (
          <div key={index} className="image-showcase__card">
            <img
              src={image}
              alt={`Showcase ${index + 1}`}
              className="image-showcase__img"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageShowcase;
